<template>
  <v-row class="px-2">
    <v-col cols="12" sm="12" md="12" class="text-center font-weight-bold d-print-block">
      Статистика по пост пакетам
      <template>
        {{ startFilterDisplayValue }}
      </template>
      по
      <template>
        {{ endFilterDisplayValue }}
      </template>
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isAllClientsSelected"
                :items="filterOptions"
                label="Выбрать все организации"
      />
    </v-col>
    <v-col cols="12" md="2" class="d-print-none">
      <v-select
          :disabled="filters.isAllClientsSelected"
          v-model="filters.clients"
          :items="clients()"
          label="Выберите организации"
          multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2" small style="background-color: #111; color: white; ">
            <span>{{ item.text }}</span>
          </v-chip>
          <span
              v-if="index === 2"
              class="text-grey text-caption align-self-center"
          >
          (+{{ filters.clients.length - 2 }} другие)
          </span>
        </template>
      </v-select>
    </v-col>
<!--    <v-col cols="12" sm="3"  md="2" class="d-flex align-center justify-center justify-md-end d-print-none">-->
<!--      <v-select v-model="filters.isArchive"-->
<!--                :items="archiveOptions"-->
<!--                label="Выбрать версию"-->

<!--      />-->
<!--    </v-col>-->
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterStartMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Начало пероида"
              v-model="startFilterDisplayValue"
              readonly
              v-on="on"
              flat
          />

        </template>
        <v-date-picker
            v-model="filters.start"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7)&&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterEndMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Конец пероида"
              v-model="endFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.end"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7) &&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="3" class="d-flex justify-end d-print-none">
      <v-btn @click="onRefreshClicked" color="primary me-2" large :disabled="disableRefreshButton" >Обновить</v-btn>
      <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
    </v-col>
    <v-col cols="12">
      <template>
        <table style="width: 100%">
          <thead>
          <tr style="background-color: aliceblue;">
            <th rowspan="2">Регион</th>
            <th rowspan="2" class="text-center filter-header">Принято за период</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(2)" class="text-center filter-header">Не распечатано за период из принятых</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(3)" class="text-center filter-header">Не сформирована за период из принятых</th>
            <th colspan="3" :class="{ 'd-print-none': !filters.selectedFilters.some(value => [4, 5, 6].includes(value)) }" :style="{ backgroundColor: filters.selectedFilters.some(value => [4, 5, 6].includes(value)) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(4, 5, 6)" class="text-center filter-header">Распечатано за период из принятых</th>
            <th colspan="3" :class="{ 'd-print-none': !filters.selectedFilters.some(value => [7, 8, 9].includes(value)) }" :style="{ backgroundColor: filters.selectedFilters.some(value => [7, 8, 9].includes(value)) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(7, 8, 9)" class="text-center filter-header">Сформирована за период из принятых</th>
          </tr>
          <tr>
            <th class="text-center filter-header" @click="toggleFilter(4)" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">Итого</th>
            <th class="text-center filter-header" @click="toggleFilter(5)" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">Срок</th>
            <th class="text-center filter-header" @click="toggleFilter(6)" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">Просрочка</th>
            <th class="text-center filter-header" @click="toggleFilter(7)" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">Итого</th>
            <th class="text-center filter-header" @click="toggleFilter(8)" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">Срок</th>
            <th class="text-center filter-header" @click="toggleFilter(9)" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }">Просрочка</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.region.id">
            <v-btn :class="{ 'd-print-none': !filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: filters.selectedRegions.includes(item.region.id) ? 'aliceblue' : '#e5e5e5' }" @click="toggleRegion(item.region.id)" class="d-flex justify-space-between" style="height: 40px; width: 100%; background-color: aliceblue; border: 1px solid black; text-align: center">
              {{ item.region.name }}
              <router-link class="d-print-none" style="text-decoration: none; color: black" :to="{name: 'report-processing-areal-task-performance', params: {regionId: item.region.id, filters: filters}}">
                <v-icon>mdi-import</v-icon>
              </router-link>
            </v-btn>
            <td :class="{ 'd-print-none': !filters.selectedRegions.includes(item.region.id), 'column': filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedRegions.includes(item.region.id) ? '#e5e5e5' : '' }" @click="itemClicked(1, item.region.id, item.received)">{{ item.received ? item.received : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2), 'column': filters.selectedFilters.includes(2) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(2) || !filters.selectedRegions.includes(item.region.id) ? '#e5e5e5' : '' }" @click="itemClicked(2, item.region.id, item.notPrintedForPeriodResult)">{{ filters.selectedFilters.includes(2) ? item.notPrintedForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3), 'column': filters.selectedFilters.includes(3) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(3) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(3, item.region.id, item.notPackedForPeriodResult)">{{ filters.selectedFilters.includes(3) ? item.notPackedForPeriodResult : ''}}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4), 'column': filters.selectedFilters.includes(4) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(4) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(4, item.region.id, item.printedForPeriodResult)">{{ filters.selectedFilters.includes(4) ? item.printedForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5), 'column': filters.selectedFilters.includes(5) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(5) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(5, item.region.id, item.printedInTimeForPeriodResult)">{{ filters.selectedFilters.includes(5) ? item.printedInTimeForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6), 'column': filters.selectedFilters.includes(6) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(6) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(6, item.region.id, item.printedExpiredForPeriodResult)">{{ filters.selectedFilters.includes(6) ? item.printedExpiredForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7), 'column': filters.selectedFilters.includes(7) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(7) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(7, item.region.id, item.packedForPeriodResult)">{{ filters.selectedFilters.includes(7) ? item.packedForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8), 'column': filters.selectedFilters.includes(8) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(8) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(8, item.region.id, item.packedInTimeForPeriodResult)">{{ filters.selectedFilters.includes(8) ? item.packedInTimeForPeriodResult : '' }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9), 'column': filters.selectedFilters.includes(9) && filters.selectedRegions.includes(item.region.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(9) || !filters.selectedRegions.includes(item.region.id)  ? '#e5e5e5' : '' }" @click="itemClicked(9, item.region.id, item.packedExpiredForPeriodResult)">{{ filters.selectedFilters.includes(9) ? item.packedExpiredForPeriodResult : '' }}</td>
          </tr>
          <tr style="background-color: aliceblue; color: black; font-weight: bold">
            <td style="height: 40px; text-align: center">Общее</td>
            <td>{{ totals.received }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ totals.notPrintedForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ totals.notPackedForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">{{ totals.printedForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">{{ totals.printedInTimeForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">{{ totals.printedExpiredForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">{{ totals.packedForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">{{ totals.packedInTimeForPeriodResult }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }">{{ totals.packedExpiredForPeriodResult }}</td>
          </tr>
          </tbody>
        </table>
        <v-dialog v-model="showModal" :persistent="true" width="1000px">
          <TaskPerformanceRegionMailsModal ref="taskPerformanceRegionMailsModal" @close-modal="closeModal"/>
        </v-dialog>
      </template>
    </v-col>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";
import TaskPerformanceRegionMailsModal
  from "@/components/report/DeliveryStatistics/Modals/TaskPerformanceRegionMailsModalComponent.vue";
import {clients} from "@/helpers/constants";


export default {
  name: "RegionalTaskPerformanceReportComponent",
  components: {TaskPerformanceRegionMailsModal},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        selectedFilters: [],
        selectedRegions: [1],
        isAllClientsSelected: false,
        isArchive: 1,
        clients: []
      },
      showModal: false,
      mails: [],
      clientsOptions: [
        { text: "МАЖБУРИЙ ИЖРО БЮРОСИ (MIB)", value: 0 },
        { text: "ГУББД (ГАИ)", value: 1 },
        { text: "Ташкент тепло-энергия (TTE)", value: 2 },
        { text: "Министерство Юстиции (JVM)", value: 3 },
        { text: "ДАВЛАТ ХИЗМАТЛАР АГЕНТЛИГИ (DXA)", value: 4 },
        { text: "Фактура.уз (FKT)", value: 5 },
        { text: "Единая система гибридной почты (EHM)", value: 6 },
        { text: "Верховный суд РУз (OSM)", value: 7 },
        { text: "ПромСтройБанк (PSB)", value: 8 },
        { text: "Прокуратура РУз (ORP)", value: 9 },
        { text: "Э-Маъмурий иш (EMI)", value: 10 },
        { text: "Народный банк (XB)", value: 11 },
        { text: "Банк Ипак Йули (IYB)", value: 12 },
        { text: "ТБС Банк (TBC)", value: 13 },
        { text: "Азия Аллианс Банк (AAB)", value: 14 },
        { text: "Асака Банк (ASK)", value: 15 },
        { text: "Тенге Банк (TNG)", value: 16 },
        { text: "Зудмолл (ZDM)", value: 17 },
        { text: "Венду (VND)", value: 18 },
        { text: "Э-Кенгаш (EKengash)", value: 19 },
        { text: "Э-ИЖРО (EJR)", value: 21 },
        { text: "Ипотека Банк (IPK)", value: 22 },
        { text: "Микрокредит Банк (MKB)", value: 23 },
        { text: "НБУ Банк (NBU)", value: 24 },
        { text: "ГУББД (ГАИ 2)", value: 25 },
        { text: "УЗИНФОКОМ (INF)", value: 26 },
        { text: "ГНК (GNK)", value: 27 },
        { text: "Давр Банк (DVR)", value: 28 },
        { text: "MEXM (MEXM)", value: 30 },
        { text: "Aloqa Bank (ALQ)", value: 31 },
        { text: "Adliya vazirligi (ADL)", value: 32 },
        { text: "Biznes rivojlantirish bank (BRB)", value: 34 },
        { text: "Kadastr (KAD)", value: 36 },
        { text: "Advokatura (ADV)", value: 38 },
        { text: "Pensiya Jamg'armasi (PJ)", value: 40 },
        { text: "Milliy Gvardiya (MG)", value: 41 },
        { text: "Solutions Lab (SL)", value: 43 },
        { text: "Agro bank (AGR)", value: 44 },
        { text: "TuronBank (TRN)", value: 50 },
        { text: "Apex (APEX)", value: 51 },
        { text: "Markaziy Bank (MBB)", value: 52 },
        { text: "xat.hippo.uz (TD)", value: 53 },
        { text: "GASN (GASN)", value: 54 }
      ],
      archiveOptions: [
        { text: '1', value: 1 }
      ],
      filterOptions: [
        { text: 'Нет', value: false },
        { text: 'Да', value: true },
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
    }
  },
  computed: {
    totals() {
      let received = 0;
      let notPrintedForPeriodResult = null;
      let notPackedForPeriodResult = null;
      let printedForPeriodResult = null;
      let printedInTimeForPeriodResult = null;
      let printedExpiredForPeriodResult = null;
      let packedForPeriodResult = null;
      let packedInTimeForPeriodResult = null;
      let packedExpiredForPeriodResult = null;

      console.log(this.filters.selectedFilters)
      _.each(this.items, item => {
        received += item.received ? item.received : 0;
        if(item.notPrintedForPeriodResult !== null)
          notPrintedForPeriodResult += item.notPrintedForPeriodResult
        if(item.notPackedForPeriodResult !== null)
          notPackedForPeriodResult += item.notPackedForPeriodResult
        if(item.printedForPeriodResult !== null)
          printedForPeriodResult += item.printedForPeriodResult
        if(item.printedInTimeForPeriodResult !== null)
          printedInTimeForPeriodResult += item.printedInTimeForPeriodResult
        if(item.printedExpiredForPeriodResult !== null)
          printedExpiredForPeriodResult += item.printedExpiredForPeriodResult
        if(item.packedForPeriodResult !== null)
          packedForPeriodResult += item.packedForPeriodResult
        if(item.packedInTimeForPeriodResult !== null)
          packedInTimeForPeriodResult += item.packedInTimeForPeriodResult
        if(item.packedExpiredForPeriodResult !== null)
          packedExpiredForPeriodResult += item.packedExpiredForPeriodResult
      });

      return {
        received: received,
        notPrintedForPeriodResult: notPrintedForPeriodResult,
        notPackedForPeriodResult: notPackedForPeriodResult,
        printedForPeriodResult: printedForPeriodResult,
        printedInTimeForPeriodResult: printedInTimeForPeriodResult,
        printedExpiredForPeriodResult: printedExpiredForPeriodResult,
        packedForPeriodResult: packedForPeriodResult,
        packedInTimeForPeriodResult: packedInTimeForPeriodResult,
        packedExpiredForPeriodResult: packedExpiredForPeriodResult
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    clients() {
      return clients
    },
    closeModal() {
      this.showModal = false;
    },
    itemClicked(filter, region, count){
      if(filter && region && count){
        this.showModal = true;

        this.$nextTick(() => {
          this.$refs.taskPerformanceRegionMailsModal.set(filter, region, this.filters, count, "Статистика пост пакетов по регионам");
        });
      }
    },
    toggleFilter(...filters) {
      filters.forEach(filter => {
        const index = this.filters.selectedFilters.findIndex(id => id === filter);
        if (index !== -1) {
          // If the filter is already selected, remove it
          this.filters.selectedFilters.splice(index, 1);
        } else {
          // If the filter is not selected, add it
          this.filters.selectedFilters.push(filter);
        }
      });
    },
    toggleRegion(regionId) {
      const index = this.filters.selectedRegions.findIndex(id => id === regionId);
      if (index !== -1) {
        this.filters.selectedRegions.splice(index, 1);
      } else {
        this.filters.selectedRegions.push(regionId);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },

    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    this.filters.selectedFilters = this.$route.params?.filters?.selectedFilters || [];
    this.filters.selectedRegions = this.$route.params?.filters?.selectedRegions || [1];
    this.filters.start = this.$route.params?.filters?.start ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = this.$route.params?.filters?.end ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')

    this.updateItems();
  }
}
</script>

<style scoped>
.filter-header {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #e5e5e9;
}

.column {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.column:hover{
  background-color: #dfe7ed;
}
th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
